import { NetworkType } from '@/config/types/rpc';
import { isMobile, isWalletBrowser } from './mobile-compatibility';

// Mobile wallet native RPC endpoints
const MOBILE_WALLET_RPCS: Record<NetworkType, string> = {
  bsc: 'https://bsc-dataseed.binance.org',
  bscTestnet: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  ethereum: 'https://eth.llamarpc.com',
  sepolia: 'https://rpc.sepolia.org',
  avalanche: 'https://api.avax.network/ext/bc/C/rpc',
  fuji: 'https://api.avax-test.network/ext/bc/C/rpc'
};

/**
 * Get the appropriate RPC URL based on the environment (mobile wallet vs desktop)
 * Mobile wallets often have their own RPC endpoints, so we should use those when available
 */
export function getEnvironmentRpcUrl(network: NetworkType): string | undefined {
  // If we're in a mobile wallet browser, return undefined to let the wallet use its native RPC
  if (isMobile && isWalletBrowser()) {
    return undefined;
  }

  // Otherwise return our configured RPC endpoint
  return MOBILE_WALLET_RPCS[network];
}
